import { Icon } from "./Icon.tsx";

/**
 * "Import GIS layers" icon — a stacked-layers glyph (the standard GIS/
 * mapping-tool convention for "layers"), distinct from DownloadIcon.tsx's
 * own down-arrow-into-a-tray ("Export .inp") — found live: both used to be
 * the exact same path data, unreadable as two different toolbar buttons.
 */
export function ImportIcon() {
  return (
    <Icon>
      <path d="M12 3 3 8l9 5 9-5-9-5Z" />
      <path d="M3 13l9 5 9-5" />
    </Icon>
  );
}
